module.exports = __webpack_public_path__ + "static/media/8.003a6a07.jpg";